<template>
  <div class="stray">
    <img src="../assets/imgs/jurisdiction.png" alt />
    <div>
      <router-link to="/login">
        <button>跳到登录页</button>
      </router-link>
      <router-link to="/">
       <button>回到首页</button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "jurisdiction",
  data() {
    return {};
  },
  components: {}
};
</script>
<style lang="less" scoped>
.stray {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  div {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    button {
      width: 92px;
      height: 32px;
      background: rgba(51,51,51,1);
      border-radius: 4px;
      color: rgba(255,255,255,1);
    }
  }
}
</style>